// Static assets & navigation for public site. Content data now comes from backend.

export const navLinks = [
  { key: 'home', label: 'Ana Səhifə', path: '/' },
  { key: 'about', label: 'Haqqımda', path: '/haqqimda' },
  { key: 'services', label: 'Xidmətlər', path: '/xidmetler' },
  { key: 'projects', label: 'Layihələr', path: '/layiheler' },
  { key: 'blog', label: 'Bloq', path: '/bloq' },
  { key: 'contact', label: 'Əlaqə', path: '/elaqe' },
  { key: 'doctors', label: 'Həkimlər', path: '/hekimler' },
];

export const heroPersonImage = 'https://images.unsplash.com/photo-1507679799987-c73779587ccf';
